import axios from "axios";

export const postLogin = (phoneNumber, password) => {
  const signInObj = {
    user_signin_form: {
      country_code: "91",
      phone_number: phoneNumber,
      password: password
    }
  };
  return axios.post(
    `${process.env.REACT_APP_SERVER_URL}/auth/sign_in`,
    signInObj
  );
};

/**
 * @function refreshToken
 * @desc This service refreshed token
 */
export const refreshToken = params => {
  const url = `${process.env.REACT_APP_SERVER_URL}/auth/refresh`;
  return axios.post(url, params);
};
